const conversations = {
  education: [
    {
      url: 'http://www.usatoday.com/story/tech/news/2016/05/04/lesbians-who-tech-dev-bootcamp-scholarships/83901964/',
      image: '/images/lps/conversations/education/lgbtq_coding_scholarship.jpg',
      title: '$200k to Fund LGBTQ Coding Scholarships',
      description: "Coding school Dev Bootcamp is joining forces with Lesbians Who Tech to provide scholarships for LGBTQ women to learn to code.",
      via: 'USA Today'
    },
    {
      url: 'http://www.forbes.com/power-women/',
      image: '/images/lps/conversations/education/most_powerful_women.jpg',
      title: 'The World\'s 100 Most Powerful Women',
      description: 'A list of this year\'s female leaders making their mark in the world today.',
      via: 'Forbes'
    },
    {
      url: 'http://www.bbc.com/news/education-36855834',
      image: '/images/lps/conversations/education/apply_top_grad_school.jpg',
      title: "Female Students Apply for Top Jobs",
      description: 'Female students are less likely to aim for top graduate jobs but likely to land them if they apply.',
      via: 'BBC News'
    },
  ],
  health: [
    {
      url: 'http://www.businessnewsdaily.com/9280-womens-health-disruptors.html#sthash.hJ6Gii9M.dpuf',
      image: '/images/lps/conversations/health/startups_womens_health.jpg',
      title: 'Startups On Women\'s Health',
      description: 'It\'s becoming more accepted to publicly address women\'s health, especially with more women-centric startups forming.',
      via: 'Business News Daily'
    },
    {
      url: 'http://www.bbc.com/news/health-36168717',
      image: '/images/lps/conversations/health/breast_cancer_milestone.jpg',
      title: 'Breast Cancer: Find Genetic Milestone',
      description: 'Scientists say they now have a near-perfect picture of the genetic events that cause breast cancer.',
      via: 'BBC News'
    },
    {
      url: 'http://www.telegraph.co.uk/women/work/how-to-be-resilient-10-life-hacks-to-help-you-beat-stress/',
      image: '/images/lps/conversations/health/ten_life_hacks.jpg',
      title: '10 Life Hacks to Help You Beat Stress',
      description: 'These tips will help you respond to anxiety powerfully and successfully deal with stressful situations.',
      via: 'The Telegraph'
    },
  ],
  entertainment: [
    {
      url: 'http://www.nytimes.com/2014/08/14/fashion/meghan-trainor-colbie-caillat-and-sara-bareilles-address-body-image-issues.html',
      image: '/images/lps/conversations/entertainment/be_yourself.jpg',
      title: 'Be Yourself, Music Videos Tell the Young',
      description: 'Meghan Trainor, Colbie Caillat and Sara Bareilles Address Body-Image Issues',
      via: 'New York Times'
    },
    {
      url: 'https://www.theguardian.com/society/2016/jul/30/hari-nef-changing-world-transgender',
      image: '/images/lps/conversations/entertainment/transgender_cover.jpg',
      title: 'Elle\’s First Transgender Cover Girl in UK',
      description: 'The magazine\'s interview with Hari Nef, the catwalk star and one of its \'icons of change\', concentrates on her talent, not her transition.',
      via: 'The Guardian'
    },
    {
      url: 'http://www.independent.co.uk/arts-entertainment/books/the-five-most-exciting-feminist-books-in-2016-a6944726.html',
      image: '/images/lps/conversations/entertainment/five_feminst_books_2016.jpg',
      title: 'Five Most Exciting Feminist Books in 2016',
      description: 'The Woman\’s Hour on BBC Radio 4 lamented the lack of "shouty" books for women, but The Independent begs to disagree.',
      via: 'The Independent'
    },
  ],
  money: [
    {
      url: 'http://www.theatlantic.com/business/archive/2016/07/equity-movie/493625/',
      image: '/images/lps/conversations/money/women_who_love_money.jpg',
      title: 'A Film About Women Who Love Money',
      description: "Equity: A film exploring the motivations, aspirations, and drawbacks of being female on Wall Street is long overdue.",
      via: 'The Atlantic'
    },
    {
      url: 'http://www.huffingtonpost.com/entry/gender-pay-gap_us_578f99a8e4b07c722ebd2791',
      image: '/images/lps/conversations/money/earning_less.jpg',
      title: 'Earning Less Isn\'t A Choice That Women Make',
      description: 'The pay gap is a complicated cultural stew.',
      via: 'Huffington Post'
    },
    {
      url:
      'http://money.usnews.com/investing/articles/2016-08-02/4-reasons-women-should-consider-hiring-a-financial-advisor',
      image: '/images/lps/conversations/money/four_reasons_hire_advisor.jpg',
      title: 'Why Women Should Hire a Financial Advisor',
      description: 'As women\'s roles evolve, making the right moves where saving and investing are concerned is a must.',
      via: 'U.S. News & World Report'
    },
  ],
  work: [
    {
      url: 'http://www.theatlantic.com/politics/archive/2016/08/gender-wage-gap-massachusetts/494045/',
      image: '/images/lps/conversations/work/equal_pay.jpg',
      title: "A Step Toward Equal Pay for Men & Women",
      description: "Massachusetts legislation aims to diminish gender-based discrimination in the workplace.",
      via: 'The Atlantic'
    },
    {
      url: 'https://www.theguardian.com/women-in-leadership/2015/may/27/five-ted-talks-that-will-change-the-way-you-work',
      image: '/images/lps/conversations/work/ted_talks.jpg',
      title: '5 TED Talks that Change the Way You Work',
      description: 'These TED Talks deliver inspiring thoughts on leadership, success and women in the workplace.',
      via: 'The Guardian'
    },
    {
      url: 'http://www.huffingtonpost.com/anne-ravanona/trailblazing-women-claire_b_10925064.html',
      image: '/images/lps/conversations/work/trail_blazing_women.jpg',
      title: 'Trailblazing Women: Claire Calmejane',
      description: 'This interview of Claire Calmejane from Lloyds Banking Group on Trailblazing Women role models from around the world.',
      via: 'Huffington Post'
    },
  ],
  entrepreneurs: [
    {
      url: 'http://www.news.cornell.edu/stories/2016/07/female-entrepreneurs-can-say-show-me-money-little-louder',
      image: '/images/lps/conversations/entrepreneurs/ask_you_shall_receive.jpg',
      title: 'Ask And You Shall Receive',
      description: "Female entrepreneurs can say 'show me the money' a little louder.",
      via: 'Cornell Chronicle'
    },
    {
      url: 'http://startups.co.uk/the-biggest-barriers-facing-female-entrepreneurs-today/',
      image: '/images/lps/conversations/entrepreneurs/barriers_facing_female_entrepreneurs.jpg',
      title: 'Barriers Facing Female Entrepreneurs',
      description: 'Five pointers to help you take the leap and realise your business dreams.',
      via: 'Startups'
    },
    {
      url: 'http://www.theepochtimes.com/n3/2112529-the-best-cities-for-female-entrepreneurs/',
      image: '/images/lps/conversations/entrepreneurs/best_cities_female_entrepreneurs.jpg',
      title: 'Best Cities for Female Entrepreneurs',
      description: 'Dell Inc. has revealed its top 25 cities in the world for female entrepreneurs.',
      via: 'Epoch Times'
    },
  ],
  'womens-rights': [
    {
      url: 'http://www.bbc.com/news/technology-36734525',
      image: '/images/lps/conversations/womens_rights/tech_push_get_girls_educated.jpg',
      title: 'Technology Push to Get Girls Educated',
      description: 'The UK\'s Department for International Development will spend £100m to help the world\'s poorest girls get an education.',
      via: 'BBC News'
    },
    {
      url: 'http://www.aljazeera.com/indepth/features/2016/07/halting-blow-domestic-violence-india-160701121800822.html',
      image: '/images/lps/conversations/womens_rights/halt_domestic_violence_india.jpg',
      title: 'Halting Domestic Violence in India',
      description: 'Few of India\'s abused women seek help. Social workers in Mumbai are trying to change that - one hospital at a time.',
      via: 'Aljazeera'
    },
    {
      url: 'http://www.worldpoliticsreview.com/trend-lines/19564/farc-peace-talks-open-the-door-to-expanded-women-s-rights-in-colombia',
      image: '/images/lps/conversations/womens_rights/womens_rights_columbia.jpg',
      title: 'Expanded Women\'s Rights in Colombia',
      description: 'Colombian government and rebels agreed to promote women’s access to property and to deny amnesty to perpetrators of sexual violence.',
      via: 'World Politics Review'
    },
  ],
  motherhood: [
    {
      url: 'https://www.washingtonpost.com/news/parenting/wp/2016/03/03/doctor-says-when-it-comes-to-breastfeeding-your-health-and-happiness-matter-as-much-as-your-babys/',
      image: '/images/lps/conversations/motherhood/breast_feeding.jpg',
      title: 'Breastfeeding Under the Weather',
      description: 'Doctor says: When it comes to breastfeeding, your health and happiness matter as much as your baby’s.',
      via: 'the Washington Post'
    },
    {
      url: 'http://www.forbes.com/sites/georgenehuang/2016/07/13/working-with-the-competition-parental-leave-brings-together-20-companies-in-the-creative-industry/#7f531973c8c2',
      image: '/images/lps/conversations/motherhood/twenty_companies_unite.jpg',
      title: '20 Companies Unite Around Parental Leave',
      description: 'Pledge Parental Leave is a coalition of creative firms making a public commitment to improve parental leave benefits for their employees.',
      via: 'Forbes'
    },
    {
      url: 'http://well.blogs.nytimes.com/2016/07/25/helping-our-school-age-children-sleep-better/?rref=collection%2Ftimestopic%2FParenting&action=click&contentCollection=timestopics&region=stream&module=stream_unit&version=search&contentPlacement=9&pgtype=collection',
      image: '/images/lps/conversations/motherhood/sleep_better.jpg',
      title: 'Helping School-Age Children Sleep Better',
      description: 'As we ask children to function in school, academically and socially, fatigue can affect their achievement and behavior.',
      via: 'the New York Times'
    },
  ],
  girls: [
    {
      url: 'http://girltalkhq.com/team-usas-2016-olympic-gymnastics-line-up-is-the-girl-power-gang-of-our-dreams/',
      image: '/images/lps/conversations/girls/girl_power.jpg',
      title: 'The Girl Power Gang Of Our Dreams',
      description: 'The five diverse young women from Team USA’s 2016 Olympic Gymnastics line-up show young girls that they too can...',
      via: 'Girl Talk HQ'
    },
    {
      url: 'http://www.theatlantic.com/business/archive/2016/08/agnes-igoye-human-trafficking/492239/',
      image: '/images/lps/conversations/girls/anti_human_trafficking.jpg',
      title: 'The Anti-Human-Trafficking Crusader',
      description: 'Agnes Igoye is building a law-enforcement system to protect Uganda’s girls.',
      via: 'Atlantic'
    },
    {
      url: 'http://www.nytimes.com/2016/01/29/business/barbie-now-in-more-shapes.html',
      image: '/images/lps/conversations/girls/barbie_adds_curvy.jpg',
      title: 'Barbie Adds Curvy and Tall Body Shapes',
      description: 'When it comes to Barbie’s body, it will no longer be one size fits all.',
      via: 'The New York Times'
    },
  ],
  invest: [
    {
      url: 'https://www.brookings.edu/2016/07/25/enabling-female-entrepreneurs-and-beyond/',
      image: '/images/lps/conversations/invest/enable_femail_entrepreneurs.jpg',
      title: 'Enabling Female Entrepreneurs and Beyond',
      description: '"We’ve seen time and again that when educated girls grow into successful women..."',
      via: 'Brookings'
    },
    {
      url: 'http://observer.com/2016/08/former-queen-of-wall-street-wants-women-to-take-control-of-their-finances/',
      image: '/images/lps/conversations/invest/femail_financiers.jpg',
      title: 'Former Wall Street Queen Calls for More Female Financiers',
      description: 'Only 18 percent of millennials (ages 18 to 25) are willing to risk their money in the market...',
      via: 'Observer'
    },
    {
      url: 'http://www.forbes.com/sites/emmajohnson/2016/03/08/5-easy-ways-to-impact-invest-in-women-and-the-world/#4a6d7c165137',
      image: '/images/lps/conversations/invest/five_ways_to_impact.jpg',
      title: '5 Ways To Impact Invest In Women',
      description: 'Marianne Haahr, director of the Global Opportunity Network, shares five simple ways you can invest in women...',
      via: 'Forbes'
    },
  ]
};

export default conversations;



// WEBPACK FOOTER //
// ./src/misc/categoryLandingConversations.js